import React from 'react'
import Carousel from 'react-bootstrap/Carousel';

const GalleryCarousel = () => {
  const importAll = (r) => {
    let images = {};
    r.keys().forEach((item, index) => { images[item.replace('./', '')] = r(item); });
    return images;
  };
  
  const images = importAll(require.context('./other', false, /\.(png|jpe?g|svg|webp)$/))

  return (
    <div className='section'>
      <Carousel className='caroselHolder' fade={true} wrap={true}>

        {Object.keys(images).map((imageName, index) => (
          <Carousel.Item key={index}>
            <img className='wideImg' src={images[imageName]} alt={imageName} />

            <Carousel.Caption className='imgCaption' bsPrefix='blub'>
              <p>{imageName.split(".")[0]}</p>
            </Carousel.Caption>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  )
}

export default GalleryCarousel